import { useState } from 'react';
import axios from 'axios';
import IconaOcchio from '../components/IconaOcchio';

const campo = 'w-full border border-gray-300 rounded-lg px-3 py-2 pr-9 text-sm focus:outline-none focus:ring-2 focus:ring-[#2E6096]';

function CampoPassword({ etichetta, valore, onChange, autoComplete }) {
  const [mostra, setMostra] = useState(false);
  return (
    <div>
      <label className="block text-xs font-medium text-gray-600 mb-1">{etichetta}</label>
      <div className="relative">
        <input
          type={mostra ? 'text' : 'password'} value={valore} required autoComplete={autoComplete}
          onChange={e => onChange(e.target.value)} className={campo}
        />
        <button type="button" onClick={() => setMostra(v => !v)}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
          aria-label={mostra ? 'Nascondi password' : 'Mostra password'}>
          <IconaOcchio barrato={mostra} />
        </button>
      </div>
    </div>
  );
}

// Pagina condivisa da admin e impresa: ognuno cambia la propria password
export default function CambiaPassword() {
  const [attuale, setAttuale] = useState('');
  const [nuova, setNuova] = useState('');
  const [conferma, setConferma] = useState('');
  const [errore, setErrore] = useState('');
  const [ok, setOk] = useState(false);
  const [saving, setSaving] = useState(false);

  async function salva(e) {
    e.preventDefault();
    setErrore('');
    setOk(false);
    if (nuova !== conferma) { setErrore('La nuova password e la conferma non coincidono'); return; }
    setSaving(true);
    try {
      await axios.post('/api/auth/cambia-password', { password_attuale: attuale, nuova_password: nuova });
      setOk(true);
      setAttuale(''); setNuova(''); setConferma('');
    } catch (err) {
      setErrore(err.response?.data?.error || 'Errore nel cambio password');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="max-w-md">
      <h1 className="text-xl sm:text-2xl font-bold text-[#1A3A5C] mb-5">Cambia password</h1>
      <form onSubmit={salva} className="bg-white rounded-xl shadow p-5 space-y-4">
        {errore && <p className="text-red-600 text-sm">{errore}</p>}
        {ok && <p className="text-green-700 text-sm">Password aggiornata.</p>}
        <CampoPassword etichetta="Password attuale" valore={attuale} onChange={setAttuale} autoComplete="current-password" />
        <CampoPassword etichetta="Nuova password" valore={nuova} onChange={setNuova} autoComplete="new-password" />
        <CampoPassword etichetta="Conferma nuova password" valore={conferma} onChange={setConferma} autoComplete="new-password" />
        <button type="submit" disabled={saving}
          className="bg-[#1A3A5C] text-white px-5 py-2 rounded-lg text-sm font-medium hover:bg-[#2E6096] transition disabled:opacity-50">
          {saving ? 'Salvo...' : 'Cambia password'}
        </button>
      </form>
    </div>
  );
}
